import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	ANALYTICS_ID,
	RESOURCE_KEY,
	RESOURCE_TYPE,
} from './JpdRecommendationDismissedResourceResourceType.constants.tsx';
import { PACKAGE_NAME } from './packageName.constants.tsx';

type JPDRecommendationDismissedResourceData = {
	hasDismissed: boolean;
};

type JPDRecommendationDismissedResourceResponse = {
	key: string;
	value: boolean;
};

export const jpdRecommendationDismissedResource: RouteResource<JPDRecommendationDismissedResourceData> =
	createResource<JPDRecommendationDismissedResourceData>({
		type: RESOURCE_TYPE,
		getKey: () => RESOURCE_KEY,
		getData: async (_, { tenantContext }): Promise<JPDRecommendationDismissedResourceData> => {
			try {
				if (tenantContext.isAnonymous) {
					return {
						hasDismissed: true,
					};
				}
				const accountId = tenantContext.atlassianAccountId;
				const response = await performGetRequest<JPDRecommendationDismissedResourceResponse>(
					`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`,
				);

				return {
					hasDismissed: response?.value ?? false,
				};
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				const initialValueNeverSet = error.statusCode === 404;
				if (initialValueNeverSet) {
					/**
					 * If the user has never set the preference, they have never dismissed.
					 */
					return {
						hasDismissed: false,
					};
				}

				fireErrorAnalytics({
					error,
					meta: {
						id: ANALYTICS_ID,
						packageName: PACKAGE_NAME,
					},
					sendToPrivacyUnsafeSplunk: true,
				});
			}

			/* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */
			return {
				hasDismissed: true,
			};
		},
		maxAge: Number.MAX_VALUE,
		isCritical: true,
	});
